export default __webpack_public_path__ + "static/media/tear-face-emoji.d3e7393c.svg";